import React, { useState } from 'react'

const Download = props => {
  const bg = "/img/counter-stats-bg.jpg"
  const [data] = useState({
    title: "Descárgala ahora!"  ,
    intro: "No esperes más! Descarga ahora nuestra nueva app y empieza a escanear!",
    msg: "* Disponible para versiones Android desde 8.0 en adelante",
    image: "/img/phone7.png",
    downloadBtns: [
      {
        category: "Android",
        extraaClass: "hover-active",
        title: "Disponible en",
        iconClass: "ti-android",
        link: 'https://play.google.com/store/apps/details?id=com.b12software.tacopaseocompras'
      },
      {
        category: "iOS",
        extraaClass: "hover-active",
        title: "Disponible en",
        iconClass: "ti-apple",
        link: 'https://apps.apple.com/ar/app/taco-paseo-de-compras/id1659240661'
      }
    ],
  });
  const [bgStyle] = useState({
    background: 'url(' + bg + ') no-repeat center center'
  })

  return(
    <section id="download" className="download-section" style={ bgStyle }>
      <div className="container">
        <div className="row">
          <div className="col-md-5 hidden-sm">
            <div className="download-app-img">
              <img src={ data.image } alt="app download" className="img-responsive" style={ { height: 500, marginRight: 'auto', marginLeft: 'auto' } } />
            </div>
          </div>
          <div className="col-md-7 col-sm-12">
            <div className="download-app-text">
              <h3>{ data.title }</h3>
              <p>{ data.intro }</p>
              <div className="download-app-button">  
                {data.downloadBtns.map(btn => (
                  <a href={ btn.link } className={`download-btn ${ btn.extraaClass }`} key={btn.category}>
                    <span className={ btn.iconClass }></span>
                    <p>
                      <small>{ btn.title }</small>
                      <br /> { btn.category }
                    </p>
                  </a>
                ))}
              </div>
              <p style={ { fontSize: '80%' } }>{ data.msg }</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default Download;